import { styled, Theme } from '@mui/material';
import { themeDefaults } from '@youscience/theme';

export const sxStyles = {
  learnMoreButton: (theme: Theme) => ({
    color: theme.palette.primary.main,
    textDecoration: 'underline',

    '&:hover': {
      cursor: 'pointer',
    },
  }),
  multipleResources: {
    display: 'flex',
    marginTop: '1rem',
  },
  cardFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '1rem',
  },
  footerInfo: {
    display: 'flex',
  },
  footerActions: {
    display: 'flex',

    '& > div:first-of-type': {
      marginRight: '1.25rem',
    },
  },
  actionIcon: {
    cursor: 'pointer',
  },
};

export const StyledTaskCardWrap = styled('div')(({ theme }) => ({
  maxWidth: '520px',
  width: '100%',
  backgroundColor: theme.palette.common.white,
  boxShadow: `0px 3px 14px 2px ${theme.palette.divider}`,
  borderRadius: '0.5rem',

  [theme.breakpoints.up('sm')]: {
    maxWidth: '684px',
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: '420px',
  },

  [theme.breakpoints.up('lg')]: {
    maxWidth: '540px',
  },

  [theme.breakpoints.up('xl')]: {
    maxWidth: '502px',
  },
}));

export const StyledTaskCardInner = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '1.5rem 1.25rem',
  minHeight: '230px',
}));

export const StyledCheckBoxWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '1.25rem',

  '& > span:first-of-type': {
    padding: 0,
    marginRight: '0.75rem',
  },
}));

export const StyledDueDate = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: '1rem',
  color: themeDefaults?.palette?.text?.secondary,

  '& > svg:first-of-type': {
    marginRight: '0.375rem',
  },
}));

export const StyledResourceLink = styled('a')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: '1rem',
  color: themeDefaults?.palette?.text?.secondary,

  '& > svg:first-of-type': {
    marginRight: '0.375rem',
  },
}));
